import css from '@styled-system/css';
const sx = props => css(props.sx);
export default sx;